import { ApmResourceIds } from '@mitsubishi/shared/data-access';

export const EXPIRING_MARKUP_RESOURCE_IDS = {
  title: 465132, // "Markup draft in scadenza"
  blockingDescription: 465133, // "Hai {0} markup non pubblicati che entreranno in vigore domani. Scegli se pubblicarli o eliminarli."
  infoDescription: 465134, // "Hai {0} markup non pubblicati che entreranno in vigore a breve."
  infoHint: 465135,
  deleteAll: 465139,
  publishAll: 465137,
  publishSuccess: 448791,
  goToWpl: 465136,
  confirm: ApmResourceIds.CONFIRMATION,
  cancel: ApmResourceIds.CANCEL,
  confirmDeleteAllTitle: 465138, // "Eliminare {0} markup?"
  bulkPublishTitle: 446080,
  bulkPublishConfirm: 465143,
  searchByName: 444894,
  noDrafts: 465144,
} as const;

export const WPL_ROUTE = '/pricing-list';
